'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useAppDispatch } from '@/store/hook';
import { resetGlobalLoading } from '@/features/ui/uiLoadingSlice';

export default function GlobalLoadingRouteReset() {
  const dispatch = useAppDispatch();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const searchParamsKey = searchParams?.toString();

  useEffect(() => {
    dispatch(resetGlobalLoading());
  }, [dispatch, pathname, searchParamsKey]);

  return null;
}
